/**
 * Rutas del **portal del cliente**.
 *
 * Al ser una aplicación aparte del panel, el portal vive en la **raíz** de su
 * propio acceso (`/resumen`, `/comprobantes`, …) en lugar de colgar de
 * `/portal-cliente` dentro de EdSuite Web. Si algún día se monta en un
 * subdirectorio (p. ej. `https://escienza.com.pe/portal/`), basta con definir
 * `VITE_BASE_PATH=/portal/`: el `basename` del router se encarga del resto y no
 * hay que tocar ninguna ruta.
 *
 * `/login` queda **fuera** del armazón del portal (no tiene sentido mostrar la
 * cabecera con el nombre del cliente antes de entrar).
 */

import { createBrowserRouter, Navigate } from 'react-router-dom';

import { PortalShell } from '@/features/portal/layouts/portal-shell';
import { PortalConductoresPage } from '@/features/portal/pages/portal-conductores-page';
import { PortalConsumosPage } from '@/features/portal/pages/portal-consumos-page';
import { PortalCreditosPage } from '@/features/portal/pages/portal-creditos-page';
import { PortalDashboardPage } from '@/features/portal/pages/portal-dashboard-page';
import { PortalDespachosPage } from '@/features/portal/pages/portal-despachos-page';
import { PortalFacturasPage } from '@/features/portal/pages/portal-facturas-page';
import { PortalLoginPage } from '@/features/portal/pages/portal-login-page';
import { PortalMensajesPage } from '@/features/portal/pages/portal-mensajes-page';
import { PortalPagosPage } from '@/features/portal/pages/portal-pagos-page';
import { PortalVehiculosPage } from '@/features/portal/pages/portal-vehiculos-page';
import { RequirePortal } from '@/features/portal/portal.guard';
import { env } from '@/config/env';

export const router = createBrowserRouter(
  [
    {
      path: '/login',
      element: <PortalLoginPage />,
    },
    {
      path: '/',
      element: (
        <RequirePortal>
          <PortalShell />
        </RequirePortal>
      ),
      children: [
        { index: true, element: <Navigate to="/resumen" replace /> },
        { path: 'resumen', element: <PortalDashboardPage /> },
        { path: 'comprobantes', element: <PortalFacturasPage /> },
        { path: 'consumos', element: <PortalConsumosPage /> },
        { path: 'despachos', element: <PortalDespachosPage /> },
        { path: 'creditos', element: <PortalCreditosPage /> },
        { path: 'pagos', element: <PortalPagosPage /> },
        { path: 'vehiculos', element: <PortalVehiculosPage /> },
        { path: 'conductores', element: <PortalConductoresPage /> },
        { path: 'mensajes', element: <PortalMensajesPage /> },
        /* Cualquier otra ruta vuelve al resumen (el enlace del cliente manda ahí). */
        { path: '*', element: <Navigate to="/resumen" replace /> },
      ],
    },
  ],
  { basename: env.basePath || undefined },
);
